/* Copyright(c) 2018, iovation, inc. All rights reserved. */
window.IGLOO = window.IGLOO || {
  loader: {
    version: 'general5',
  },
};
